export default __webpack_public_path__ + "static/media/call-xs.cdcb0d89.svg";